import {
  APPLY_APPROVAL_NUMBER_TO_EMBRYOS,
  CREATE_FREEZE_VALIDATION_REPORT,
  PDF_CREATE_FREEZE,
  UPDATE_BILL_ACCOUNT_CANING_GROUPS,
  UPDATE_MATING_LABELS_FREEZE,
  UPDATE_OD_FREEZE,
  VALIDATE_FREEZE,
} from '@/rtk-query.gql';

import { enhancedApi } from '../api/baseApi';

export const freezeApi = enhancedApi.injectEndpoints({
  endpoints: (build) => ({
    updateODFreeze: build.mutation({
      query: (variables) => ({
        document: UPDATE_OD_FREEZE,
        variables,
      }),
    }),
    pdfCreateFreeze: build.mutation({
      query: (variables) => ({
        document: PDF_CREATE_FREEZE,
        variables,
      }),
    }),
    validateFreeze: build.mutation({
      query: (variables) => ({
        document: VALIDATE_FREEZE,
        variables,
      }),
      invalidatesTags: ['FertilizationListFreeze'],
    }),
    applyApprovalNumbersToEmbryos: build.mutation({
      query: (variables) => ({
        document: APPLY_APPROVAL_NUMBER_TO_EMBRYOS,
        variables,
      }),
      invalidatesTags: ['EmbryosFreeze'],
    }),
    createFreezeValidationReport: build.mutation({
      query: (variables) => ({
        document: CREATE_FREEZE_VALIDATION_REPORT,
        variables,
      }),
    }),
    updateMatingLabelsFreeze: build.mutation({
      query: (variables) => ({
        document: UPDATE_MATING_LABELS_FREEZE,
        variables,
      }),
    }),
    updateBillAccountCaningGroups: build.mutation({
      query: (variables) => ({
        document: UPDATE_BILL_ACCOUNT_CANING_GROUPS,
        variables,
      }),
      invalidatesTags: ['EmbryosFreeze', 'FertilizationListFreeze'],
    }),
  }),
});

export const {
  useUpdateODFreezeMutation,
  usePdfCreateFreezeMutation,
  useValidateFreezeMutation,
  useApplyApprovalNumbersToEmbryosMutation,
  useCreateFreezeValidationReportMutation,
  useUpdateMatingLabelsFreezeMutation,
  useUpdateBillAccountCaningGroupsMutation,
} = freezeApi;
